/** Class used to filter prices. */

export class Prices {

    /** Price ID */
    public id: number | null;

    /** Price name. */
    public label: string;

    /** Attributes min and max are used to set a price range. */
    /** Minimum price. */
    public min: number | null;

    /** Maximum price. */
    public max: number | null;

    constructor(
        id = NaN || null,
        label = "",
        min = NaN || null,
        max = NaN || null
    ) {
        this.id = id;
        this.label = label;
        this.min = min;
        this.max = max;
    }
}